module.exports = __webpack_public_path__ + "static/media/Marathon newspaper.7a7e9fbb.jpg";